import { render } from "./FormGrid.vue?vue&type=template&id=17711af7&ts=true"
import script from "./FormGrid.ts?vue&type=script&lang=ts&external"
export * from "./FormGrid.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__